import { Wrapper, Status } from "@googlemaps/react-wrapper";
import styled from "styled-components";

import Loading from "components/Loading";

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY as string;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

/**
 * google mapをラップしたコンポーネント
 * @props children GoogleMapパーツで出来たJSX
 */
const GoogleMap = ({ children }: { children?: JSX.Element }) => {
  if (typeof window === "undefined") return <></>;

  const render = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return (
          <Wrap>
            <Loading />
          </Wrap>
        );
      case Status.FAILURE:
        return (
          <Wrap>
            <span>Error</span>
          </Wrap>
        );
      case Status.SUCCESS:
        return <Wrap>{children}</Wrap>;
    }
  };

  return <Wrapper apiKey={GOOGLE_MAP_API_KEY} render={render} />;
};

export default GoogleMap;
